var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13225_64075)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3335 3.86884L11.4957 8.05586C10.9698 9.25393 9.84069 10.0756 8.54063 10.2064L3.9972 10.6633L7.40479 13.7079C8.37984 14.5791 8.81112 15.9086 8.53352 17.1875L7.56335 21.6569L11.5072 19.3516C12.6357 18.6919 14.0313 18.6919 15.1598 19.3516L19.1036 21.6569L18.1335 17.1875C17.8559 15.9086 18.2871 14.5791 19.2622 13.7079L22.6698 10.6633L18.1264 10.2064C16.8263 10.0756 15.6972 9.25393 15.1713 8.05586L13.3335 3.86884ZM13.9963 2.35872L13.9969 2.35746L13.9963 2.35872ZM14.6603 1.48099C14.1526 0.324369 12.5144 0.324371 12.0067 1.48099L9.50547 7.1794C9.29512 7.65862 8.84348 7.9873 8.32345 8.0396L2.13998 8.66144C0.8849 8.78766 0.378659 10.3483 1.31997 11.1893L5.9576 15.333C6.34762 15.6815 6.52013 16.2133 6.40909 16.7248L5.08872 22.8076C4.82072 24.0422 6.14609 25.0067 7.23553 24.3699L12.603 21.2324C13.0544 20.9685 13.6126 20.9685 14.064 21.2324L19.4315 24.3699C20.5209 25.0067 21.8463 24.0422 21.5783 22.8076L20.2579 16.7248C20.1469 16.2133 20.3194 15.6815 20.7094 15.333L25.347 11.1893C26.2883 10.3483 25.7821 8.78766 24.527 8.66144L18.3435 8.0396C17.8235 7.9873 17.3719 7.65862 17.1615 7.1794L14.6603 1.48099Z",
    fill: "grey"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13225_64080",
    x1: -2.61562,
    y1: 8.40238,
    x2: 25.4036,
    y2: 18.9332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--gradient-start)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--gradient-end)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13225_64075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.833496 0.0927734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.d558942b7a8148eee4ea399ce5cf4c0f.svg";
export { ForwardRef as ReactComponent };